<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @taskAdd="taskAddFun"
        @taskSubmit="taskSubmitFun"
        @taskCheck="taskCheckFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.supplierName"
              placeholder="请输入供应商名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.type"
              placeholder="请选择订单类型"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="masterList.tableQuery.search.searchStartDate"
              type="date"
              placeholder="选择订单开始日期"
              style="width:100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="masterList.tableQuery.search.searchEndDate"
              type="date"
              placeholder="选择订单结束日期"
              style="width:100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.status"
              placeholder="请选择订单状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @delete="deleteFun(arguments)"
        @submit="submitFun(arguments)"
        @back="backFun(arguments)"
        @check="checkFun(arguments)"
        @revoke="revokeFun(arguments)"
        @shipment="shipmentFun(arguments)"
        @adjust="adjustFun(arguments)"
        @dblclick="viewFun(arguments)"
        @upload="uploadFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>
    <!-- 修改 -->
    <add-edit-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 更新进度 -->
    <shipment-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogShipmentVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 调整价格 -->
    <adjust-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogAdjustVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
    />

    <!-- 待办列表 -->
    <task-list-dialog
      :dialog-visible.sync="dialogTaskVisible"
      :dialog-title="dialogTaskTitle"
      @reloadData="loadTableData()"
    />
    <task-submit-dialog
      :dialog-visible.sync="dialogTodoSubmitVisible"
      :dialog-title="dialogTaskTitle"
      @reloadData="loadTableData()"
    />
    <task-check-dialog
      :dialog-visible.sync="dialogTodoCheckVisible"
      :dialog-title="dialogTaskTitle"
      @reloadData="loadTableData()"
    />
    <!-- 上传附件 -->
    <upload-dialog
      :data-id="id"
      :directory="'commissionedOrder'"
      :source-type="'18'"
      :list-type="'picture'"
      :file-accept="'.jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF'"
      :dialog-visible.sync="dialogUploadVisible"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 修改
import addEditDialog from './components/addEditDialog'
// 更新进度
import shipmentDialog from './components/shipmentDialog'
// 调整价格
import adjustDialog from './components/adjustDialog'
// 查看
import viewDialog from './components/viewDialog'
// 待办列表
import taskListDialog from './components/taskListDialog'
import taskSubmitDialog from './components/taskSubmitDialog'
import taskCheckDialog from './components/taskCheckDialog'
// 上传附件
import UploadDialog from '@/components/UploadDialog'
// 数据请求
import { loadCommissionedOrderListDataApi, loadCommissionedOrderExportDataApi, countTodoCommissionedOrderApi, removeCommissionedOrderApi, submitCommissionedOrderApi, backCommissionedOrderApi, checkCommissionedOrderApi, revokeCommissionedOrderApi } from '@/api/materialsCommissionedOrder'
import { countTodoMaterialsDemandApi } from '@/api/materialsDemandDetail'

export default {
  name: 'MaterialsCommissionedOrder',
  components: {
    CustomTable,
    TableOperation,
    addEditDialog,
    shipmentDialog,
    adjustDialog,
    viewDialog,
    taskListDialog,
    taskSubmitDialog,
    taskCheckDialog,
    UploadDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'materials_commissioned_order', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['commissioned_order_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['commissioned_order_submit'],
            prop: 'submit',
            label: '提交',
            method: 'submit'
          },
          {
            permissionSigns: ['commissioned_order_check'],
            prop: 'back',
            label: '退回',
            method: 'back'
          },
          {
            permissionSigns: ['commissioned_order_check'],
            prop: 'check',
            label: '复核',
            method: 'check'
          },
          {
            permissionSigns: ['commissioned_order_revoke'],
            prop: 'revoke',
            label: '撤销复核',
            method: 'revoke'
          },
          {
            permissionSigns: ['commissioned_order_process'],
            prop: 'shipment',
            label: '更新进度',
            method: 'shipment'
          },
          {
            permissionSigns: ['commissioned_order_adjust'],
            prop: 'adjust',
            label: '调整价格',
            method: 'adjust'
          },
          {
            permissionSigns: ['commissioned_order_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['commissioned_order_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['commissioned_order_edit'],
            prop: 'upload',
            label: '上传附件',
            method: 'upload'
          },
          {
            permissionSigns: ['commissioned_order_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            supplierName: '',
            type: '',
            searchStartDate: '',
            searchEndDate: '',
            status: '',
            supplier: 1 // 总部制作
          }
        },
        notPaging: true
      },
      // 待办
      todoList: [
        {
          permissionSigns: ['commissioned_order_add'],
          label: '待制定物料委托制作单',
          method: 'taskAdd',
          count: 0
        },
        {
          permissionSigns: ['commissioned_order_submit'],
          label: '待提交物料委托制作单',
          method: 'taskSubmit',
          count: 0
        },
        {
          permissionSigns: ['commissioned_order_check'],
          label: '待复核物料委托制作单',
          method: 'taskCheck',
          count: 0
        }
      ],
      typeOptions: [{ value: 1, label: '委托制作' }, { value: 2, label: '购买' }],
      statusOptions: [{ value: 1, label: '制单' }, { value: 3, label: '提交' }, { value: 2, label: '复核' }],
      id: null, // 选中的单据ID
      eventType: '',
      // 弹框组件标题名称
      dialogTitle: '',
      // 新增修改弹框组件
      dialogAddEditVisible: false,
      // 更新进度弹框组件
      dialogShipmentVisible: false,
      // 调整价格弹框组件
      dialogAdjustVisible: false,
      // 查看弹框组件
      dialogViewVisible: false,
      // 新增待办弹框组件
      dialogTaskVisible: false,
      // 提交待办弹框组件
      dialogTodoSubmitVisible: false,
      // 复核待办弹框组件
      dialogTodoCheckVisible: false,
      dialogUploadVisible: false,
      dialogTaskTitle: ''
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'id', label: '单据编号', filterColumn: 'id', width: 105 },
      { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 90 },
      { prop: 'cityName', label: '市场', filterColumn: 'city_name', width: 100 },
      { prop: 'supplierName', label: '供应商名称', filterColumn: 'supplier_name', width: 200 },
      { prop: 'typeValue', label: '订单类型', filterColumn: 'type', filterValue: 'type', filterArray: this.typeOptions, width: 105 },
      { prop: 'orderDateValue', label: '订单日期', filterColumn: 'order_date', width: 120 },
      { prop: 'makeMaterials', label: '物料信息', filterColumn: 'make_materials', width: 400 },
      { prop: 'makeProcessValue', label: '制作进度', filterColumn: 'make_process', filterValue: 'makeProcess', width: 110 },
      { prop: 'shipmentProcessValue', label: '发货进度', filterColumn: 'shipment_process', filterValue: 'shipmentProcess', width: 110 },
      { prop: 'receiveProcessValue', label: '收货进度', filterColumn: 'receive_process', filterValue: 'receiveProcess', width: 110 },
      { prop: 'orderAmount', label: '订单金额', filterColumn: 'order_amount', width: 130, isPrice: true, isBetween: true },
      { prop: 'makeAmount', label: '物料制作金额', filterColumn: 'make_amount', width: 130, isPrice: true, isBetween: true },
      { prop: 'otherAmount', label: '其他费用金额', filterColumn: 'other_amount', width: 130, isPrice: true, isBetween: true },
      { prop: 'otherReason', label: '其他费用说明', filterColumn: 'other_reason', width: 150 },
      { prop: 'paidAmount', label: '已付款金额', filterColumn: 'paid_amount', width: 120, isPrice: true, isBetween: true },
      { prop: 'invoiceAmount', label: '收票金额', filterColumn: 'invoice_amount', width: 120, isPrice: true, isBetween: true },
      { prop: 'manager', label: '经办人', filterColumn: 'manager', width: 100 },
      { prop: 'estimatedCompleteDateValue', label: '预计完成日期', filterColumn: 'estimated_complete_date', width: 130 },
      { prop: 'completeDateValue', label: '实际完成日期', filterColumn: 'complete_date', width: 130 },
      { prop: 'statusValue', label: '申请状态', filterColumn: 'status', filterValue: 'status', filterArray: this.statusOptions, width: 110 },
      { prop: 'creator', filterColumn: 'creator', label: '创建人', width: 110 },
      { prop: 'createTimeValue', filterColumn: 'create_time', label: '创建时间', width: 150, isBetween: true },
      { prop: 'submitter', filterColumn: 'submitter', label: '提交人', width: 110 },
      { prop: 'submitTimeValue', filterColumn: 'submit_time', label: '提交时间', width: 150, isBetween: true },
      { prop: 'checker', filterColumn: 'checker', label: '复核人', width: 110 },
      { prop: 'checkTimeValue', filterColumn: 'check_time', label: '复核时间', width: 150, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = false
      loadCommissionedOrderListDataApi({ condition: JSON.stringify(this.masterList.tableQuery) }).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data || []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount () {
      // 待制定物料委托制作单数量
      countTodoMaterialsDemandApi({ type: 'make', confirmSupplier: 1 }).then(res => {
        this.todoList[0].count = res.data || 0
      })
      // 待提交的物料委托制作单数量
      countTodoCommissionedOrderApi({ status: '1', supplier: 1 }).then(res => {
        this.todoList[1].count = res.data || 0
      })
      // 待复核的物料委托制作单数量
      countTodoCommissionedOrderApi({ status: '3', supplier: 1 }).then(res => {
        this.todoList[2].count = res.data || 0
      })
    },
    // 新增待办
    taskAddFun () {
      this.dialogTaskTitle = '待制定物料委托制作单'
      this.dialogTaskVisible = !this.dialogTaskVisible
    },
    // 提交待办
    taskSubmitFun () {
      this.dialogTaskTitle = '待提交物料委托制作单'
      this.dialogTodoSubmitVisible = !this.dialogTodoSubmitVisible
    },
    // 复核待办
    taskCheckFun () {
      this.dialogTaskTitle = '待提交物料委托制作单'
      this.dialogTodoCheckVisible = !this.dialogTodoCheckVisible
    },
    // 上传附件
    uploadFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.dialogUploadVisible = !this.dialogUploadVisible
    },
    // 新增
    addFun () {
      let _this = this
      _this.eventType = 'add'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
      _this.dialogTitle = '新增物料委托制作单'
    },
    // 修改
    editFun (args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的物料委托制作单', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        _this.$message({ message: '物料委托制作单不是制单状态，不能修改', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogTitle = '修改物料委托制作单'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 查看
    viewFun (args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的物料委托制作单', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogTitle = '查看物料委托制作单'
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 作废
    deleteFun (args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要作废的物料委托制作单', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        _this.$message({ message: '物料委托制作单不是制单状态，不能作废', type: 'warning' })
        return
      }
      _this.$confirm('是否确定作废该物料委托制作单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        removeCommissionedOrderApi({ id: args[0].id }).then(res => {
          if (res.mark === '200') {
            _this.$message({ message: res.message, type: 'success' })
            _this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 提交
    submitFun (args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要提交的物料委托制作单', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        _this.$message({ message: '物料委托制作单不是制单状态，不能提交', type: 'warning' })
        return
      }
      _this.$confirm('是否确定提交该物料委托制作单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        submitCommissionedOrderApi({ id: args[0].id }).then(res => {
          if (res.mark === '200') {
            _this.$message({ message: res.message, type: 'success' })
            _this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 退回
    backFun (args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要退回的物料委托制作单', type: 'warning' })
        return
      } else if (args[0].status !== 3) {
        _this.$message({ message: '物料委托制作单不是提交状态，不能退回', type: 'warning' })
        return
      }

      _this.$confirm('是否确定退回该物料委托制作单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        backCommissionedOrderApi({ id: args[0].id }).then(res => {
          if (res.mark === '200') {
            _this.$message({ message: res.message, type: 'success' })
            _this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 复核
    checkFun (args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要复核的物料委托制作单', type: 'warning' })
        return
      } else if (args[0].status !== 3) {
        _this.$message({ message: '物料委托制作单不是提交状态，不能复核', type: 'warning' })
        return
      }

      _this.$confirm('是否确定复核该物料委托制作单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        checkCommissionedOrderApi({ id: args[0].id }).then(res => {
          if (res.mark === '200') {
            _this.$message({ message: res.message, type: 'success' })
            _this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 撤销
    revokeFun (args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要撤销复核的物料委托制作单', type: 'warning' })
        return
      } else if (args[0].status !== 2) {
        _this.$message({ message: '物料委托制作单不是复核状态，不能复核', type: 'warning' })
        return
      }

      _this.$confirm('是否确定撤销该物料委托制作单的复核操作？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        revokeCommissionedOrderApi({ id: args[0].id }).then(res => {
          if (res.mark === '200') {
            _this.$message({ message: res.message, type: 'success' })
            _this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 更新制作单进度
    shipmentFun (args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要更新进度的物料委托制作单', type: 'warning' })
        return
      } else if (args[0].status !== 2) {
        _this.$message({ message: '物料委托制作单不是复核状态，不能更新进度', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'process'
      _this.dialogTitle = '更新委托制作单进度'
      _this.dialogShipmentVisible = !_this.dialogShipmentVisible
    },
    // 调整价格
    adjustFun (args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要调整价格的物料委托制作单', type: 'warning' })
        return
      } else if (args[0].status !== 2) {
        _this.$message({ message: '物料委托制作单不是复核状态，请使用修改功能', type: 'warning' })
        return
      }

      _this.id = args[0].id
      _this.eventType = 'adjust'
      _this.dialogTitle = '调整委托制作单制作价格'
      _this.dialogAdjustVisible = !_this.dialogAdjustVisible
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadCommissionedOrderExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
